<script setup lang="ts">
import { computed } from 'vue'
import { useDrawerStore } from '@/stores/drawer'
import { storeToRefs } from 'pinia'
import { useDisplay } from 'vuetify'

import ProjectTitle from '@/components/project-detail/ProjectTitle.vue'
import { useProjectUserPermissions } from '@/composables/useProjectUserPermissions'
import { CALCULATION_ROUTE_NAMES } from '@/router/routeNames'

const allNavigationItems = [
  {
    title: 'Project Overview',
    icon: 'mdi-home',
    event: 'calculation-index'
  },
  {
    title: 'User Management',
    icon: 'mdi-account-group',
    event: 'user-management'
  },
  {
    title: 'Hardware Profiles',
    icon: 'mdi-server',
    event: 'project-hardware-profiles'
  }
]

const drawerStore = useDrawerStore()
const { drawer } = storeToRefs(drawerStore)
const { canViewProjectUsers } = useProjectUserPermissions()

const { smAndDown } = useDisplay()

const navigationItems = computed(() =>
  allNavigationItems.filter((item) => item.event !== 'user-management' || canViewProjectUsers.value)
)
const drawerWidth = computed(() => (drawer.value.shown ? drawer.value.width : 60))

const drawerModel = computed({
  get: () => {
    return smAndDown.value ? drawer.value.shown : true
  },
  set: (val) => {
    drawer.value.shown = val
  }
})
</script>

<template>
  <v-navigation-drawer
    v-model="drawerModel"
    :mini-variant="!smAndDown && !drawer.shown"
    :width="drawerWidth"
    :permanent="!smAndDown"
  >
    <v-list class="py-0">
      <v-list-item-title v-if="drawer.shown && !smAndDown">
        <ProjectTitle />
      </v-list-item-title>
      <v-divider></v-divider>

      <v-list-item
        v-for="item in navigationItems"
        :key="item.event"
        :to="{ name: item.event, params: { id: $route.params.id } }"
        :active="
          $route.name === item.event ||
          (item.event === 'calculation-index' &&
            CALCULATION_ROUTE_NAMES.includes(
              String($route.name) as (typeof CALCULATION_ROUTE_NAMES)[number]
            ))
        "
        color="primary"
      >
        <div :class="drawer.shown ? 'd-flex align-center' : 'd-flex flex-column justify-center'">
          <v-icon style="opacity: 1" :icon="item.icon" color="primary" size="large" />
          <div v-if="drawer.shown" class="px-3">
            {{ item.title }}
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
